import React, { useState, useRef, useEffect } from "react";
import { Form, Button, Alert } from "react-bootstrap";
import partnerAxios from "../services/partnerAxios";

const getErr = (err, fallback) => err.response?.data?.error || fallback;
const SUGGESTIONS = [
  "How many bookings did I get this month?",
  "Show my pending settlements",
  "Which of my services are inactive?",
  "Do I have any open disputes?",
];

export default function Assistant() {
  const [messages, setMessages] = useState([]);
  const [text, setText] = useState("");
  const [sending, setSending] = useState(false);
  const [error, setError] = useState("");
  const bottomRef = useRef(null);

  useEffect(() => {
    bottomRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [messages]);

  const send = async (overrideText) => {
    const value = (overrideText ?? text).trim();
    if (!value || sending) return;
    setMessages((m) => [...m, { role: "user", content: value }]);
    setText("");
    setSending(true);
    setError("");
    try {
      const { data } = await partnerAxios.post("/priya/partner/message", { text: value });
      setMessages((m) => [...m, { role: "assistant", content: data.data.reply }]);
    } catch (err) {
      setError(getErr(err, "Priya couldn't respond just now."));
      setMessages((m) => [...m, { role: "assistant", content: "Sorry, something went wrong. Please try again." }]);
    } finally {
      setSending(false);
    }
  };

  return (
    <div>
      <h4 className="mb-3">Ask Priya</h4>
      {error && <Alert variant="danger">{error}</Alert>}

      <div className="partner-card mb-3" style={{ minHeight: 320, maxHeight: 440, overflowY: "auto" }}>
        {messages.length === 0 ? (
          <div className="text-center text-muted py-4">
            <p className="mb-3">Ask Priya anything about your bookings, earnings, services, or disputes — she only answers from your real account data.</p>
            <div className="d-flex flex-column gap-2 align-items-center">
              {SUGGESTIONS.map((s) => (
                <Button key={s} size="sm" variant="outline-secondary" onClick={() => send(s)}>{s}</Button>
              ))}
            </div>
          </div>
        ) : (
          <div className="d-flex flex-column gap-2">
            {messages.map((m, i) => (
              <div key={i} className={`d-flex ${m.role === "user" ? "justify-content-end" : "justify-content-start"}`}>
                <div
                  className="px-3 py-2 rounded-3"
                  style={{ maxWidth: "75%", background: m.role === "user" ? "#fff3ee" : "#f3f4f6", whiteSpace: "pre-wrap" }}
                >
                  {m.content}
                </div>
              </div>
            ))}
            {sending && <div className="text-muted small">Priya is checking your account…</div>}
            <div ref={bottomRef} />
          </div>
        )}
      </div>

      <Form onSubmit={(e) => { e.preventDefault(); send(); }} className="d-flex gap-2">
        <Form.Control placeholder="Ask about earnings, bookings, services…" value={text} onChange={(e) => setText(e.target.value)} />
        <Button type="submit" disabled={sending}>{sending ? "Sending…" : "Send"}</Button>
      </Form>
    </div>
  );
}
